import React, { useState, useEffect } from "react";

const SquareLoader = ({ label = "Loading", color = "rgb(107, 113, 251)" }) => {
  const [rotate, setRotate] = useState(45);

  useEffect(() => {
    const interval = setInterval(() => setRotate(r => r + 45), 1000);
    return () => clearInterval(interval);
  }, []);

  const loaderShapeStyle = {
    background: color,
    height: '4px',
    width: '4px',
    transition: 'transform 1s',
  };

  const loaderLabelStyle = {
    color: color,
    fontFamily: "'Lato', sans-serif",
    fontSize: 18,
  };

  const loaderStyle = {
    display: 'inline-flex',
    gap: '10px',
    width: '100%',
    height: '25px',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '20px',
  };

  return (
    <div style={loaderStyle}>
      {label && <div style={loaderLabelStyle}>{label}</div>}
      <div style={{ ...loaderShapeStyle, transform: `rotate(${rotate}deg)` }}></div>
      <div style={{ ...loaderShapeStyle, transform: `rotate(${rotate + 45}deg)` }}></div>
      <div style={{ ...loaderShapeStyle, transform: `rotate(${rotate}deg)` }}></div>
    </div>
  );
};

export default SquareLoader;
